import { asyncAction } from 'lib/actionCreators'

export const candidateAssignedJobs = asyncAction('candidate/DASHBOARD_ASSIGNED_JOBS')
export const candidateAppliedJobs = asyncAction('candidate/DASHBOARD_APPLIED_JOBS')
export const getInvitedCandidates = asyncAction('candidate/DASHBOARD_INVITED_CANDIDATES')
export const getPendingCandidates = asyncAction('candidate/DASHBOARD_PENDING_CANDIDATES')
export const candidateFavoriteJobs = asyncAction('candidate/DASHBOARD_FAVORITE_JOBS')
export const candidateRecommendedJobs = asyncAction('candidate/DASHBOARD_RECOMMENDED_JOBS')
export const getPointsInfo = asyncAction('candidate/DASHBOARD_POINTS_INFO')
